import { useInfiniteQuery, useQuery } from 'react-query';
import { AppliedUserParams, ImpersonationQueryParams } from './app-center.types';
import { AppCenterAPI } from 'api';
import { get } from 'services/request.service';
import { APP_CENTER_API_URL } from './app-center.constants';

export const useGetAppliedUsers = (params: AppliedUserParams, enabled = false) => {
  const PAGESIZE = 10;
  const { keyword } = params;

  return useInfiniteQuery(
    ['appliedusers', keyword],
    ({ pageParam = 1 }) => AppCenterAPI.getAppliedUsers(params, pageParam),
    {
      getNextPageParam: (lastPage, allPages) => {
        const nextPage = lastPage.length === PAGESIZE ? allPages.length + 1 : undefined;
        return nextPage;
      },
      enabled
    }
  );
};

export const useGetImpersonationList = (params: ImpersonationQueryParams, page = 1) => {
  return useQuery(
    ['impersonation-list', params],
    () => AppCenterAPI.getImpersonationList(params, page),
    {
      staleTime: Infinity,
      cacheTime: Infinity,
      enabled: false
    }
  );
};
